import React, { useContext, useState } from "react";
import Header from "./Header";
import PricingCards from "./PricingCards";
import { AuthContext, API_BASE_URL } from "../App";
import { pricingData } from "../pricingData";
import { WAITLIST_MODE, WAITLIST_URL } from "../config";
import "./PricingPage.css";

export default function PricingPage() {
  const { authToken, user } = useContext(AuthContext);
  const [cycle, setCycle] = useState(pricingData.defaultCycle);

  const handleSubscribe = async () => {
    if (WAITLIST_MODE) {
      window.open(WAITLIST_URL, "_blank");
      return;
    }
    if (!authToken) return window.location.assign("/login?redirect=/pricing");
    if (user?.plan === "premium") return alert("Already on Plus plan");
    const res = await fetch(`${API_BASE_URL}/api/create-checkout-session`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify({ cycle }),
    });
    const { checkoutUrl } = await res.json();
    window.location.href = checkoutUrl;
  };

  return (
    <div className="pricing-page-container">
      <Header />
      <div className="pricing-page-content container">
        <h1>Choose Your Plan</h1>

        <div className="pricing-cards">
          <PricingCards
            pricingData={pricingData}
            handleSubscribe={handleSubscribe}
          ></PricingCards>
        </div>
      </div>
    </div>
  );
}
